var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
const Link = (_a) => {
    var { className, href, target, download = false, children, disabled } = _a, props = __rest(_a, ["className", "href", "target", "download", "children", "disabled"]);
    return (_jsx("a", Object.assign({ className: className, disabled: disabled, target: target }, (download ? download : ''), { href: href }, props, { children: children })));
};
export default Link;
